import { piniaOfficeOffer } from '@stores/useOfficeOfferStore';
import { createApp } from 'vue';
import OtherOffers from './OtherOffers.vue';

export const initOtherOffers = () => {
  if (!document.getElementById('combinator-other-offers-app')) {
    return;
  }

  const app = createApp(OtherOffers);

  app.use(piniaOfficeOffer);
  app.mount('#combinator-other-offers-app');
};
